<template>
  <div class="content-box bg-gray" v-if="courseDetail">
    <div class="banner">
      <video-player
        v-if="videoUrl"
        class="video-player-box"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
      />
    </div>
    <div class="content-normal title-box">
      <h5>第{{courseDetail.package_ordinal}}课 - {{courseDetail.name}}</h5>
      <p>{{courseDetail.description}}</p>
    </div>
    <el-collapse v-model="activeName" @change="handleChange" accordion>
      <el-collapse-item v-for="(item, index) of cTabContent" :key="index" :name="item.tabType" class="collapse-item">
        <template slot="title">
          <components :is="detailIcons[item.icon]" class="icon"></components>
          <span>{{item.name}}</span>
        </template>
        <ul class="content">
          <li v-for="(m, i) in selectList" :key="i" @click="selectTab(i, item.viewType, m.resource_url)" :class="{'tab-active': tabIndex === i}">{{formatFileName(m.resource_url)}}</li>
        </ul>
      </el-collapse-item>
    </el-collapse>
    <no-work-placeholder v-if="!cTabContent.length" tip="老师还未发送课件，请联系老师"/>
  </div>
</template>
<script>
import 'video.js/dist/video-js.css'
import { videoPlayer as VideoPlayer } from 'vue-video-player'
import { get, post } from '@/utils/ajax'
import { importSvg, formatFileName } from '@/utils'
import NoWorkPlaceholder from './NoWorkPlaceholder'
export default {
  name: 'CourseDetail',
  async created() {
    await this.refresh()
    if (!this.isCustom) {
      this.detail && this.detail.video_url.length && this.selectTab(0, 'video', this.detail.video_url[0].resource_url)
    } else {
      this.detail && this.detail.video_url && this.selectTab(0, 'video', this.detail.video_url)
    }
    this.$store.dispatch('reportClassroomPageVisitParents')
  },
  data() {
    return {
      playerOptions: {
        // videojs options
        bigPlayButton: false,
        fluid: true,
        language: 'cn',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [],
        poster: require('@/assets/images/video_bg@3x.jpg')
      },
      detail: null,
      videoUrl: null,
      detailIcons: importSvg(require.context('@/assets/svg', false, /\.svg$/)),
      courseDetail: JSON.parse(sessionStorage.getItem('courseDetail')),
      activeName: '',
      tabIndex: '',
      selectList: [],
      tabContent: [
        {
          viewType: 'video',
          name: '视频',
          icon: './icon_video.svg',
          isShow: true,
          tabType: 'video'
        },
        {
          viewType: 'pdf',
          name: '课件',
          icon: './icon_courseware.svg',
          isShow: true,
          tabType: 'courseWare'
        },
        {
          viewType: 'pdf',
          name: '任务单',
          icon: './icon_mission.svg',
          isShow: true,
          tabType: 'mission'
        }
      ]
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    isCustom() {
      return this.$route.query.isCustom === 'true'
    },
    cTabContent() {
      return this.tabContent.filter(v => v.isShow)
    }
  },
  methods: {
    formatFileName,
    async refresh() {
      this.detail = await get(
        `/edu/wap/${this.isCustom ? 'upload' : 'lesson'}/packages/lessons/${
          this.id
        }`
      )
      this.tabContent[0].isShow = this.detail.video_url && this.detail.video_url.length > 0
      this.tabContent[1].isShow = this.detail.courseware_url && this.detail.courseware_url.length > 0
      this.tabContent[2].isShow = this.detail.mission_url && this.detail.mission_url.length > 0
    },
    async getResourceUrl (viewType, url) {
      const { resource_url } = await post(`/edu/qiniu/resource/url`, { resource_path: url })
      switch (viewType) {
        case 'video':
          this.videoUrl = resource_url
          const data = {
            type: 'video/mp4',
            src: `${resource_url}&time=${new Date().getTime()}`
          }
          this.$set(this.playerOptions.sources, 0, data)
          break
        case 'pdf':
          this.openPDF(resource_url)
          break
      }
    },
    openPDF(url) {
      this.$store.commit('SETVIEWERURL', url)
      this.$router.push({ name: 'viewer' })
    },
    handleChange (val) {
      this.tabIndex = ''
      // 官方返回数组，备课返回字符串，这里做区分
      if (!this.isCustom) {
        switch (val) {
          case 'video':
            this.tabType = 'video'
            this.selectList = this.detail.video_url
            break
          case 'courseWare':
            this.tabType = 'courseWare'
            this.selectList = this.detail.courseware_url
            break
          case 'mission':
            this.tabType = 'mission'
            this.selectList = this.detail.mission_url
            break
        }
      } else {
        switch (val) {
          case 'video':
            this.tabType = 'video'
            this.selectList = this.detail.video_url && [{ resource_url: this.detail.video_url }]
            break
          case 'courseWare':
            this.tabType = 'courseWare'
            this.selectList = this.detail.courseware_url && [{ resource_url: this.detail.courseware_url }]
            break
          case 'mission':
            this.tabType = 'mission'
            this.selectList = this.detail.mission_url && [{ resource_url: this.detail.mission_url }]
            break
        }
      }
    },
    selectTab(tabIndex, viewType, url) {
      this.tabIndex = tabIndex
      this.getResourceUrl(viewType, url)
    }
  },
  components: {
    VideoPlayer,
    NoWorkPlaceholder
  }
}
</script>
<style lang="stylus" scoped>
.video-player-box
  width 100%
>>>.vjs-fluid
  padding-top 0
  height 211px
.bg-gray
  background-color #f4f4f4
  overflow-x hidden
.banner
  height 211px
  background-fit('~@/assets/images/video_bg')
.title-box
  background-color white
  padding-top 10px
  padding-bottom 10px
  margin-bottom 10px
.assets-list
  background-color white
  padding-left 30px
  li
    display flex
    align-items center
    justify-content space-between
    padding 13px 30px 13px 0
    // border-1('%23f4f4f4', 'bottom')
    border-bottom 1px solid #f4f4f4
    &:last-child
      border-bottom none
    span
      flex-grow 1
  .icon
    width 24px
    height 24px
    margin-right 10px
  .right-icon
    fill #c0c0c0
    width 8px
    height 14px
.content
  li
    height:48px;
    line-height 50px;
    background:#FAFAFA;
    border-bottom 1px solid #F6F6F6
    color: #666
    padding-left 64px
    white-space: nowrap;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
  li:last-child
    border: 0;
  .tab-active
    color $themeColor
>>>.el-collapse-item__header
  padding: 0 26px 0 30px;
  border-bottom: 1px solid #F6F6F6;
  i
    color #C0C0C0;
    font-size 16px;
.collapse-item
  svg
    width 24px;
    height 24px;
    vertical-align middle;
    margin -5px 10px 0 0;
>>>.el-collapse-item__content
  padding-bottom: 0;
>>>.el-collapse-item__arrow
  transform: rotate(90deg);
>>>.el-collapse-item__arrow.is-active
  transform: rotate(-90deg);
</style>
